import {
  setItem,
  removeItem
} from '@/common/storage'
import {
  setUserIp
} from '@/common/cookies'
export default {
  SET_CLIENT_WIDTH(state, width) {
    state.clientWidth = width
  },
  SET_USER_IP(state, ip) {
    state.userIp = ip
    setUserIp(ip)
  },
  SET_DEVICE(state, type) {
    state.deviceType = type
  },
  SET_HISTORY_TAGS(state, arr) {
    state.historyTags = arr
    setItem('historyTags', arr)
  },
  SET_SUBSCRIBE(state, sub) {
    state.subscribe = sub
    if (sub) {
      setItem('subscribe', sub)
    } else {
      removeItem('subscribe')
    }
  }
}
